<template>
  <div class="app-layout-members" :class="memberShow ? 'is-member': ''">
    <div v-if="!memberShow">
      <!-- для новой версии текст и кнопка Скачать электронный каталог -->
      <div class="app-layout-members__top" v-if="isNewVersion">
        <div class="app-layout-members__info">
          {{ topInfoText }}
        </div>
        <div class="app-layout-members__action" v-if="data.downloadAll && isNewVersion">
          <AppButton :data="data.downloadAll"/>
        </div>
      </div>

      <form class="app-layout-members__filters" @submit.prevent="filtration">
        <div class="app-layout-members__filter" :class="[filter.search ? 'search' : '',
        filter.favorites ? 'link' : '', filter.favorites === false ? 'link' : '',
        filter.select ? 'select' : '']" v-for="(filter, idx) in filters"
             :key="`filter${idx}`">
          <AppFilterItem :data="filter"
                         @change="filterChange"
                         @favorites-active="favoritesShow(true)"
                         @favorites-inactive="favoritesShow()"/>
        </div>
        <div class="app-layout-members__form-action" v-if="actions">
          <AppButton :data="action" v-for="(action, idx) in actions" :key="`actionForm${idx}`"/>
        </div>
      </form>
      <template v-if="showMembers.length > 0">
        <ul class="app-layout-members__items">
          <li class="app-layout-members__item" v-for="(item, idx) in showMembers"
              :key="`member${idx}`">
            <AppCardMember :data="item"
                           @member-open="memberOpen" @favorites="toggleFavorites"/></li>
        </ul>
        <div class="app-layout-members__bottom">
          <div class="app-layout-members__pagination"
               v-if="showMembers.length >= itemsPerPage || loading">
            <AppButton :disabled=loading :data="showMore" @click="loadMore"/>
          </div>
          <div class="app-layout-members__action" v-if="data.downloadAll && !isNewVersion">
            <AppButton :data="data.downloadAll"/>
          </div>
        </div>
      </template>
      <div class="app-layout-members__empty" v-else>{{ emptyMessage }}</div>
    </div>

    <AppLayoutMember :data="activeMember" @member-close="memberClose"
                     v-if="memberShow"/>
  </div>
</template>

<script>

import AppCardMember from '@/components/app-card-member/app-card-member.vue';
import AppButton from '@/components/app-button/app-button.vue';
import AppFilterItem from '@/components/app-filter-item/app-filter-item.vue';
import AppLayoutMember from '@/components/app-layout-member/app-layout-member.vue';
import _get from 'lodash.get';

export default {
  name: 'AppLayoutMembers',
  components: {
    AppCardMember,
    AppButton,
    AppFilterItem,
    AppLayoutMember,
  },
  props: ['data', 'year', 'type', 'isNewVersion'],
  data() {
    return {
      loading: false,
      memberShow: false,
      activeMemberId: null,
      favoritesActive: false,
      showMembers: [],
      favoriteMembers: [],
      showCount: 1,
      showPerPage: 20,
      itemsPerPage: 20,
      showMore: false,
      showMoreDisabled: false,
      filters: [],
      actions: [],
      members: [],
      emptyMessage: null,
      topInfoText: null,
      lang: this.data.lang || 'ru',
    };
  },
  methods: {
    async loadMore() {
      if (this.loading) return;
      this.showCount += 1;
      this.itemsPerPage = this.showCount * this.showPerPage;
      sessionStorage.itemsPerPage = this.itemsPerPage;
      const config = {
        params: {
          lang: this.lang,
          count: this.itemsPerPage,
        },
      };

      if (this.year) {
        config.params.year = this.year;
      }
      if (this.type) {
        config.params.type = this.type;
      }

      if (sessionStorage.filters) {
        this.filters.forEach((el) => {
          const filters = JSON.parse(sessionStorage.filters);
          if (el.value) {
            config.params[`${el.name}`] = filters[el.name];
          }
        });
      }
      try {
        this.loading = true;
        const result = await this.$api.get('/api/participants/get', config);
        if (result) {
          this.members = _get(result, 'data.data.record.members', null);
          this.members.forEach((el) => {
            this.$set(el, 'favorites', false);
            this.$set(el, 'closeText', this.data.closeText);
            this.$set(el, 'inFavorites', this.data.favorites.inFavorites);
            this.$set(el, 'outFavorites', this.data.favorites.outFavorites);
          });
          if (localStorage.favoriteMembers) {
            this.favoriteMembers = JSON.parse(localStorage.favoriteMembers);

            this.members.forEach((el) => {
              // eslint-disable-next-line no-param-reassign
              el.favorites = this.favoriteMembers.includes(el.id);
            });
          }
          this.showMembers = this.members;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    filterChange(name, valueName, value) {
      this.filters.forEach((filter) => {
        if (filter.name === name) {
          const filters = {};
          this.$set(filter, 'value', valueName);
          if (filter.select) {
            filters[filter.name] = value;
          } else {
            filters[filter.name] = valueName;
          }
          if (sessionStorage.filters) {
            const prevs = JSON.parse(sessionStorage.filters);
            sessionStorage.filters = JSON.stringify({ ...prevs, ...filters });
          } else {
            sessionStorage.filters = JSON.stringify(filters);
          }
        }
      });
    },

    favoritesShow(state) {
      if (state) {
        this.showMembers = this.members.filter((el) => this.favoriteMembers.includes(el.id));
        this.favoritesActive = true;
      } else {
        this.showMembers = this.members;
        this.favoritesActive = false;
      }
    },

    async filtration() {
      const config = {
        params: {
          lang: this.lang,
          count: this.itemsPerPage,
        },
      };

      if (this.year) {
        config.params.year = this.year;
      }
      if (this.type) {
        config.params.type = this.type;
      }

      if (sessionStorage.filters) {
        this.filters.forEach((el) => {
          const filters = JSON.parse(sessionStorage.filters);
          if (el.value) {
            config.params[`${el.name}`] = filters[el.name];
          }
        });
      }
      try {
        this.loading = true;
        const result = await this.$api.get('/api/participants/get', config);
        if (result) {
          this.members = _get(result, 'data.data.record.members', null);
          if (this.members.status && this.members.status === 'empty') {
            this.members = [];
          }
          this.members.forEach((el) => {
            this.$set(el, 'favorites', false);
            this.$set(el, 'closeText', this.data.closeText);
            this.$set(el, 'inFavorites', this.data.favorites.inFavorites);
            this.$set(el, 'outFavorites', this.data.favorites.outFavorites);
          });
          this.showMembers = this.members;
          if (localStorage.favoriteMembers) {
            this.favoriteMembers = JSON.parse(localStorage.favoriteMembers);

            this.members.forEach((el) => {
              // eslint-disable-next-line no-param-reassign
              el.favorites = this.favoriteMembers.includes(el.id);
            });
          }
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
    memberOpen(id) {
      this.activeMemberId = id;
      this.memberShow = true;
      window.location.hash = `member-${this.activeMemberId}`;
      this.disableScroll();
    },

    memberClose() {
      this.$emit('member-close');
      this.memberShow = false;
      window.history.pushState('', '', `${window.location.pathname}${window.location.search}`);
      this.$nextTick(() => {
        this.enableScroll();
      });
    },

    toggleFavorites(id) {
      if (this.favoriteMembers.indexOf(id) !== -1) {
        const index = this.favoriteMembers.indexOf(id);
        this.favoriteMembers.splice(index, 1);
      } else {
        this.favoriteMembers.push(id);
      }

      localStorage.favoriteMembers = JSON.stringify(this.favoriteMembers);
      this.members.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.favorites = this.favoriteMembers.includes(el.id);
      });
      if (this.favoritesActive) {
        this.favoritesShow(true);
      } else {
        this.favoritesShow();
      }
    },

    popState() {
      const { hash } = window.location;
      if (hash) {
        const hashArr = hash.split('-');
        this.memberOpen(hashArr[1]);
      } else {
        this.memberClose();
      }
    },

    disableScroll() {
      const { body } = document;
      if (body.classList.contains('scroll-disabled')) return;
      body.classList.remove('scroll-enabled');
      body.classList.add('scroll-disabled');
      const scrollY = window.pageYOffset;
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
    },

    enableScroll() {
      const { body } = document;
      if (body.classList.contains('scroll-enabled')) return;
      body.classList.remove('scroll-disabled');
      body.classList.add('scroll-enabled');
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    },
  },
  computed: {
    activeMember() {
      let active = [];
      if (this.activeMemberId) {
        active = this.members.filter((ev) => ev.id === this.activeMemberId);
      }
      return active[0];
    },
  },
  mounted() {
    const { hash } = window.location;
    if (hash) {
      const hashArr = hash.split('-');
      this.memberOpen(hashArr[1]);
    }
    window.addEventListener('popstate', this.popState);
    this.members = this.data.members;
    this.showMore = this.data.showMore;
    if (!this.data.showMore.more || this.data.showMore.more === false) {
      this.showMore.more = true;
    }
    this.filters = this.data.filters;
    this.actions = this.data.actions;
    this.emptyMessage = this.data.emptyMessage || 'К сожалению, по вашему запросу ничего не найдено';
    this.topInfoText = this.data.downloadAll.description || 'В мероприятии участвуют представители органов власти, бизнеса и различных организаций, имеющих прямое отношение к развитию торгово-промышленного сотрудничества.';
    if (this.members.length) {
      this.members.forEach((el) => {
        this.$set(el, 'favorites', false);
        this.$set(el, 'closeText', this.data.closeText);
        this.$set(el, 'inFavorites', this.data.favorites.inFavorites);
        this.$set(el, 'outFavorites', this.data.favorites.outFavorites);
      });
      if (localStorage.favoriteMembers) {
        this.favoriteMembers = JSON.parse(localStorage.favoriteMembers);

        this.members.forEach((el) => {
          // eslint-disable-next-line no-param-reassign
          el.favorites = this.favoriteMembers.includes(el.id);
        });
      }

      this.showMembers = this.members;
    }

    if (this.filters.length && sessionStorage.filters) {
      const filters = JSON.parse(sessionStorage.filters);
      this.filters.forEach((filter) => {
        if (filters[filter.name]) {
          if (filter.select) {
            this.$set(filter, 'value', filter.select.options[filters[filter.name]]);
          }
          if (filter.search) {
            this.$set(filter, 'value', filters[filter.name]);
          }
        }
      });
      if (sessionStorage.itemsPerPage) {
        this.itemsPerPage = sessionStorage.itemsPerPage;
      }
      this.filtration();
    }
  },

  beforeDestroy() {
    window.history.pushState('', '', `${window.location.pathname}${window.location.search}`);
    window.removeEventListener('popstate', this.popState);
  },
};

</script>

<style lang="scss">
  @import "app-layout-members";
</style>
